// Bridge to allow non-React code (like axios interceptors) to use React Router navigation
let _navigate = null;

export const setNavigate = (navigateFn) => {
  _navigate = navigateFn;
};

export const appNavigate = (path) => {
  if (_navigate) {
    _navigate(path);
  } else {
    window.location.href = path;
  }
};
